import "twin.macro";

import { formatMoneyString } from "@utility/utilityFunctions";

import { useDemandPlanSummaryQuery } from "../data/demandPlanQueries";

export const DemandPlanSummaryInfo = ({
  demandPlanId,
}: {
  demandPlanId: string | null | undefined;
}) => {
  // Load Summary totals for demand plan
  const { data: summary } = useDemandPlanSummaryQuery(demandPlanId);

  return (
    <div tw="px-3 py-1 rounded bg-neutral-50 text-neutral-700 text-base border border-neutral-300 border-solid min-w-[230px]">
      <div tw="flex text-sm justify-between">
        <div>In-Progress Costs</div>
        <div tw="font-bold text-right pl-3">
          {formatMoneyString(summary?.unreviewedCost)}
        </div>
      </div>
      <div tw="flex text-sm justify-between">
        <div>Reviewed Costs</div>
        <div tw="font-bold text-right">
          {formatMoneyString(summary?.reviewedCost)}
        </div>
      </div>
      <div tw="flex text-sm justify-between">
        <div>Total Costs</div>
        <div tw="font-bold text-right">
          {formatMoneyString(summary?.totalCost)}
        </div>
      </div>
    </div>
  );
};
